import { useEffect } from 'react';
import { useToastStore, type ToastType } from '../store/useToastStore';
import { getPermissionApplyUrl } from '../lib/gatekeeperUrls';

const TOAST_STYLE: Record<ToastType, { bg: string; border: string; color: string; icon: React.ReactNode }> = {
  success: {
    bg: '#16281f',
    border: '#24543a',
    color: '#dcfce7',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.2" width="18" height="18" style={{ flexShrink: 0 }}>
        <circle cx="12" cy="12" r="9" />
        <path d="m8.5 12 2.3 2.3 4.7-5.1" />
      </svg>
    ),
  },
  error: {
    bg: '#2b1717',
    border: '#7f1d1d',
    color: '#fee2e2',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.2" width="18" height="18" style={{ flexShrink: 0 }}>
        <circle cx="12" cy="12" r="9" />
        <path d="M9 9l6 6M15 9l-6 6" />
      </svg>
    ),
  },
  warning: {
    bg: '#1f2937',
    border: '#374151',
    color: '#f3f4f6',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" width="18" height="18" style={{ flexShrink: 0 }}>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    ),
  },
  info: {
    bg: '#172554',
    border: '#1d4ed8',
    color: '#dbeafe',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#60a5fa" strokeWidth="2.2" width="18" height="18" style={{ flexShrink: 0 }}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 10v5" />
        <path d="M12 7h.01" />
      </svg>
    ),
  },
};

export function Toast() {
  const message = useToastStore((s) => s.message);
  const type = useToastStore((s) => s.type);
  const hide = useToastStore((s) => s.hide);

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(hide, 5000);
    return () => clearTimeout(timer);
  }, [message, hide]);

  if (!message) return null;

  const style = TOAST_STYLE[type];
  const shouldShowApply = type === 'warning' && /权限/.test(message);

  return (
    <div
      style={{
        position: 'fixed',
        top: 72,
        right: 24,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '12px 16px',
        borderRadius: 8,
        background: style.bg,
        border: `1px solid ${style.border}`,
        boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
        color: style.color,
        fontSize: 14,
        maxWidth: 460,
      }}
    >
      {style.icon}
      <span style={{ flex: 1 }}>{message}</span>
      {shouldShowApply && (
        <a
          href={getPermissionApplyUrl()}
          target="_blank"
          rel="noreferrer"
          onClick={hide}
          style={{
            padding: '4px 10px',
            borderRadius: 6,
            background: '#4f46e5',
            color: '#fff',
            textDecoration: 'none',
            fontSize: 13,
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          去申请
        </a>
      )}
      <button
        onClick={hide}
        style={{
          background: 'none',
          border: 'none',
          color: 'inherit',
          opacity: 0.55,
          cursor: 'pointer',
          padding: '0 2px',
          fontSize: 16,
          lineHeight: 1,
          flexShrink: 0,
        }}
      >
        ×
      </button>
    </div>
  );
}
